import React from "react";
import { connect } from "react-redux";

import * as actions from "../actions/actions";
import IconList from "../legacy/components/iconlist";
import { NoIconResults } from "../components/nounproject-iconlist-classic-no-results";
import SearchInfoBarContainer from "./infobar";

import get_parameter_by_name from "../legacy/helpers/get_parameter_by_name";

function getQueryParams(props) {
    let { location } = props;
    let { search: queryString } = location;
    let query, collection, creator, icon;

    query = get_parameter_by_name("q", queryString);
    collection = get_parameter_by_name("collection", queryString);
    creator = get_parameter_by_name("creator", queryString);
    icon = get_parameter_by_name("i", queryString);

    query = query || "";

    return {
        icon,
        query,
        collection,
        creator
    };
}

class NounProjectResults extends React.Component {
    componentWillReceiveProps(nextProps) {
        let { pageContext } = this.props;
        let { pageContext: nextPageContext } = nextProps;
        let {
            query: nextQuery,
            collection: nextCollection,
            creator: nextCreator
        } = getQueryParams(nextProps);

        let { query, collection, creator } = getQueryParams(this.props);

        if (
            pageContext != nextPageContext ||
            query != nextQuery ||
            collection != nextCollection ||
            creator != nextCreator
        ) {
            // clear the previous query results
            this.props.searchResetIcons(this.props.query);
            this.loadIcons({ ...nextProps, page: 0 });
        }
    }

    componentWillMount() {
        this.props.searchResetIcons(this.props.query);
        this.loadIcons({ ...this.props, page: 0 });

        // The icon hero manages its own scroll position when it mounts
        if (global.history) {
            global.history.scrollRestoration = "manual";
        }
        this.props.searchRegisterResults(true);
    }

    componentWillUnmount() {
        if (global.history) {
            global.history.scrollRestoration = "auto";
        }
        this.props.searchRegisterResults(false);
    }

    loadIcons = props => {
        props = props || this.props;

        let { page, pageContext, match } = props;
        let { query, collection, creator } = getQueryParams(props);

        let { params } = match;

        switch (pageContext) {
            case "search":
                if (creator) {
                    // search creator's icons
                    this.props.searchCreatorIcons(query, creator, page + 1);
                } else if (collection) {
                    if (query) {
                        // search collections's icons
                        this.props.searchCollectionIcons(
                            query,
                            collection,
                            page + 1
                        );
                    } else {
                        this.props.fetchCollection(collection, page + 1);
                    }
                } else {
                    // normal search
                    this.props.searchIcons(query, page + 1);
                }
                break;
            case "termDetail":
                let { term } = params;
                this.props.searchTerm(term, page + 1);
                break;
            case "recent":
                this.props.fetchRecentIcons(72, page + 1);
                break;
            case "browse":
                this.props.fetchBestCollectionIcons(72, page + 1);
                break;
            case "userUploads":
                let { username } = params;
                this.props.searchCreatorUploads(username, page + 1);
                break;
            case "collectionDetail": {
                if (this.props.args) {
                    let { collection } = this.props.args;
                    if (collection) {
                        this.props.fetchCollection(
                            collection.id,
                            this.props.page + 1
                        );
                    }
                }
                break;
            }
        }
    };
    render() {
        let { query, collection, creator, noResults } = this.props;
        let { didYouMean } = this.props;

        let infoBar;
        if (this.props.pageContext === "search") {
            infoBar = (
                <SearchInfoBarContainer
                    searchType="icons"
                    query={query}
                    didYouMean={didYouMean}
                />
            );
        }

        let content;
        if (noResults) {
            content = (
                <NoIconResults
                    query={query}
                    creator={creator}
                    collection={collection}
                    suggestion={didYouMean}
                />
            );
        } else {
            content = (
                <IconList
                    location={this.props.location}
                    history={this.props.history}
                    activeIconId={this.props.activeIconId}
                    loadIcons={this.loadIcons}
                    icons={this.props.icons}
                />
            );
        }
        return (
            <>
                {infoBar}
                {content}
            </>
        );
    }
}

function findPaginationState(state, props) {
    let { match, pageContext } = props;
    let { params } = match;

    let { query, collection, creator } = getQueryParams(props);

    switch (pageContext) {
        case "search":
            if (creator) {
                // search creator's icons
                return state.pagination.searchCreatorIcons["userIcons"];
            } else if (collection) {
                // search collection's icons
                return state.pagination.searchCollectionIcons[
                    "collectionIcons"
                ];
            } else {
                if (!query) {
                    return null;
                }
                if (
                    Object.prototype.hasOwnProperty.call(
                        state.pagination.searchIcons,
                        query
                    )
                ) {
                    return state.pagination.searchIcons[query];
                } else {
                    return {};
                }
            }

        case "termDetail":
            let { term } = params;

            if (
                Object.prototype.hasOwnProperty.call(
                    state.pagination.searchTerm,
                    term
                )
            ) {
                return state.pagination.searchTerm[term];
            } else {
                return {};
            }

        case "recent":
            return state.pagination.fetchRecentIcons["recent"];

        case "browse":
            return state.pagination.fetchBestCollectionIcons["browse"];

        case "userUploads":
            return state.pagination.searchCreatorUploads["userUploads"];

        case "collectionDetail":
            return state.pagination.fetchCollection["collectionIcon"];
    }
}

function mapStateToProps(state, props) {
    let { apiResponse, icons: iconsState } = state;
    let pagination = findPaginationState(state, props);
    let page, pageKeys;

    let isSearchPage = props.pageContext == "search";
    let isTermDetail = props.pageContext == "termDetail";
    let isCollectionDetail = props.pageContext == "collectionDetail";

    if (pagination) {
        ({ pageCount: page, keys: pageKeys } = pagination);
    }

    let queryParams = getQueryParams(props);

    if (!page) {
        page = 0;
    }
    let { processing } = iconsState;
    let keys = pageKeys || iconsState.keys || [];

    let icons = keys.map(key => {
        return iconsState[key];
    });

    let { did_you_mean: didYouMean } = iconsState;

    let activeIconId = queryParams.icon ? queryParams.icon : null;
    if (isTermDetail) {
        activeIconId = props.match.params.iconId;
    }
    let { query, collection, creator } = queryParams;

    let isBlankCollectionSearch = collection && !query && icons.length;
    let isBlankIconSearch =
        (state.icons.counts && state.icons.counts.icons === 0) ||
        state.icons.search_total === 0 ||
        (isSearchPage && !state.icons.query);
    let noResults =
        !processing && isBlankIconSearch && !isBlankCollectionSearch;

    return {
        apiResponse,
        page,
        icons,
        didYouMean,
        activeIconId,
        query,
        collection,
        creator,
        noResults
    };
}
NounProjectResults.defaultProps = {
    pageContext: "browse"
};

export default connect(mapStateToProps, {
    fetchBestCollectionIcons: actions.fetchBestCollectionIcons,
    fetchCollection: actions.fetchCollection,
    fetchRecentIcons: actions.fetchRecentIcons,
    searchCreatorIcons: actions.searchCreatorIcons,
    searchCreatorUploads: actions.searchCreatorUploads,
    searchCollectionIcons: actions.searchCollectionIcons,
    searchIcons: actions.searchIcons,
    searchResetIcons: actions.searchResetIcons,
    searchTerm: actions.searchTerm,
    searchRegisterResults: actions.searchRegisterResults,
    downloadShowAuth: actions.downloadShowAuth,
    dismissModal: actions.dismissModal
})(NounProjectResults);
